import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/digg': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M81.7 172.3v-76.3h51v250.7h-132.7v-174.4h81.7zM81.7 305.7v-92.3h-30.8v92.3h30.8zM378.9 172.3h133.1v243.7h-133.1v-40.8h81.8v-28.5h-81.8v-174.4zM460.7 305.7v-92.3h-30.8v92.3h30.8zM225.1 346.7v-174.4h133.3v243.7h-133.3v-40.8h82.1v-28.5h-82.1zM276.3 213.4v92.3h30.8v-92.3h-30.8zM153.3 96h51.3v51h-51.3v-51zM153.3 172.3h51.3v174.4h-51.3v-174.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/digg.js
// module id = 794
// module chunks = 0